import { Button, CircularProgress, Tooltip } from '@material-ui/core';

export enum ButtonTypeEnum {
	Submit = 'submit',
	Button = 'button',
	Reset = 'reset',
}

export enum ButtonColorEnum {
	Inherit = 'inherit',
	Primary = 'primary',
	Secondary = 'secondary',
	Default = 'default',
}

export enum ButtonVariantEnum {
	Text = 'text',
	Outlined = 'outlined',
	Contained = 'contained',
}

export enum ButtonSizeEnum {
	Small = 'small',
	Medium = 'medium',
	Large = 'large',
}

export interface ICustomButtonProps {
	buttonText?: string;
	loading?: boolean;
	disabled?: boolean;
	fullWidth?: boolean;
	type?: ButtonTypeEnum;
	color?: ButtonColorEnum;
	variant?: ButtonVariantEnum;
	size?: ButtonSizeEnum;
	disableFocusRipple?: boolean;
	children?: React.ReactNode;
	href?: string;
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	autoFocus?: boolean;
	showTooltip?: boolean;
	startIcon?: JSX.Element;
	endIcon?: JSX.Element;
	className?: any;
	tooltipTitle: string;
	tooltipPosition?:
		| 'bottom-end'
		| 'bottom-start'
		| 'bottom'
		| 'left-end'
		| 'left-start'
		| 'left'
		| 'right-end'
		| 'right-start'
		| 'right'
		| 'top-end'
		| 'top-start'
		| 'top';
}

const defaultProps: ICustomButtonProps = {
	type: ButtonTypeEnum.Submit,
	color: ButtonColorEnum.Primary,
	fullWidth: false,
	disabled: false,
	loading: false,
	variant: ButtonVariantEnum.Outlined,
	size: ButtonSizeEnum.Medium,
	disableFocusRipple: false,
	onClick: () => { },
	tooltipTitle: '',
	autoFocus: false
};

const CustomButton = (props: ICustomButtonProps) => {
	const button = (
		<Button
			className={props?.className}
			type={props.type}
			fullWidth={props.fullWidth}
			color={props.color}
			disabled={props.disabled}
			variant={props.variant}
			size={props.size}
			startIcon={props.startIcon}
			endIcon={props.endIcon}
			disableFocusRipple={props.disableFocusRipple}
			href={props.href}
			onClick={e => {
				props!.onClick!(e);
			}}
			autoFocus={props.autoFocus}
		>
			{props.buttonText}
			{props.children}
			{props.loading && <CircularProgress size={16} style={{ marginLeft: 2 }} />}
		</Button>
	);

	if (!props.showTooltip) {
		return button;
	}

	return (
		<Tooltip title={props.tooltipTitle} placement={props.tooltipPosition}>
			{button}
		</Tooltip>
	);
};

CustomButton.defaultProps = defaultProps;

export default CustomButton;
